import React from 'react';
import { NumericFormat } from 'react-number-format';
import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function ClosedDealAmountField({
  value,
  error,
  setValue,
  setError,
}) {
  const handleChange = (values) => {
    setValue(values.floatValue);
  };
  return (
    <Box>
      <FormControl fullWidth required>
        <NumericFormat
          value={value}
          prefix='$'
          onValueChange={handleChange}
          customInput={TextField}
          aria-describedby='amount-helper-text'
          label='Investment Amount'
          id='amount'
          error={Boolean(error) || value === ''}
          variant='standard'
          thousandSeparator=','
          required
        />

        {error ? (
          <FormHelperText id='amount-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='amount-helper-text'>
            Enter the equity amount sold to investors.
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
